import { createApp } from 'vue';

import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
import '@/styles/index.scss'; // global css

import plugins from './plugins'; // plugins

import * as ECharts from 'echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';

// 自定义指令
import directive from './directives';

import App from './App';
import store from './store';
import router from './router';

import SvgIcon from '@/icons'; // icon
import './permission'; // permission control

import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@vueup/vue-quill/dist/vue-quill.bubble.css';

// 公共组件
import Editor from '@/components/Editor';
import SearchForm from '@/components/SearchForm';
import SubmitForm from '@/components/SubmitForm';
import TableContainer from '@/components/TableContainer';
import Drawer from '@/components/Drawer';

const app = createApp(App);

// 全局属性
app.config.globalProperties.$echarts = ECharts;
app.config.productionTip = false;

// 全局错误处理 - 静默处理网络错误和 ResizeObserver 警告
app.config.errorHandler = (err, instance, info) => {
  // 忽略网络错误，不在页面显示
  if (err && err.message && err.message.includes('Network Error')) {
    return;
  }
  // 忽略 ResizeObserver 警告（浏览器机制，不影响功能）
  if (err) {
    const errStr = typeof err === 'string' ? err : err.message || '';
    if (errStr.includes('ResizeObserver')) {
      return;
    }
  }
  // 其他错误可以记录到日志
  console.error('Global error:', err, info);
};

// Element Plus 图标全局注册
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(store);
app.use(router);
app.use(plugins);
app.use(ElementPlus, { size: 'default', locale: zhCn });

// 自定义指令
directive(app);

// 富文本组件（@vueup/vue-quill）
app.component('QuillEditor', QuillEditor);

// 全局公共组件
app.component('svg-icon', SvgIcon);
app.component('search-form', SearchForm);
app.component('submit-form', SubmitForm);
app.component('table-container', TableContainer);
app.component('drawer', Drawer);
app.component('editor', Editor);

app.mount('#app');
